import { ENV } from "constant";
import { Helmet } from "react-helmet-async";

const SEO = ({ title, description }) => {
  if (ENV === "production") {
    return (
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
      </Helmet>
    );
  }
};

export default SEO;
